/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import {
  BonusBalances,
  BonusBalancesFromJSON,
  BonusBalancesToJSON,
  Bonuses,
  BonusesFromJSON,
  BonusesToJSON,
  ClaimHistory,
  ClaimHistoryFromJSON,
  ClaimHistoryToJSON,
  ClaimRequest,
  ClaimRequestFromJSON,
  ClaimRequestToJSON,
  FarmHolderBonusPoolInfo,
  FarmHolderBonusPoolInfoFromJSON,
  FarmHolderBonusPoolInfoToJSON,
  HolderBonusesResponse,
  HolderBonusesResponseFromJSON,
  HolderBonusesResponseToJSON,
} from '../models'

export interface ClaimOperationRequest {
  claimRequest?: ClaimRequest
}

/**
 *
 */
export class BonusesApi extends runtime.BaseAPI {
  /**
   */
  async claimRaw(
    requestParameters: ClaimOperationRequest,
    initOverrides?: RequestInit,
  ): Promise<runtime.ApiResponse<void>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    const response = await this.request(
      {
        path: `/api/private/claim`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: ClaimRequestToJSON(requestParameters.claimRequest),
      },
      initOverrides,
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   */
  async claim(requestParameters: ClaimOperationRequest = {}, initOverrides?: RequestInit): Promise<void> {
    await this.claimRaw(requestParameters, initOverrides)
  }

  /**
   */
  async getBalancesRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<BonusBalances>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/private/bonuses`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, (jsonValue) => BonusBalancesFromJSON(jsonValue))
  }

  /**
   */
  async getBalances(initOverrides?: RequestInit): Promise<BonusBalances> {
    const response = await this.getBalancesRaw(initOverrides)
    return await response.value()
  }

  /**
   */
  async getClaimHistoryRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<ClaimHistory>>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/private/claim/history`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ClaimHistoryFromJSON))
  }

  /**
   */
  async getClaimHistory(initOverrides?: RequestInit): Promise<Array<ClaimHistory>> {
    const response = await this.getClaimHistoryRaw(initOverrides)
    return await response.value()
  }

  /**
   * @deprecated API endpoint no longer available
   */
  async getFarmsHolderBonusPoolRaw(
    initOverrides?: RequestInit,
  ): Promise<runtime.ApiResponse<Array<FarmHolderBonusPoolInfo>>> {
    // API endpoint no longer available - returning empty array
    return new runtime.JSONApiResponse(new Response(JSON.stringify([]), { status: 200 }), () => [])
  }

  /**
   * @deprecated API endpoint no longer available
   */
  async getFarmsHolderBonusPool(initOverrides?: RequestInit): Promise<Array<FarmHolderBonusPoolInfo>> {
    // API endpoint no longer available - returning empty array
    return []
  }

  /**
   */
  async getFarmsHolderBonusesRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<HolderBonusesResponse>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/private/farms/holder-bonus`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, (jsonValue) => HolderBonusesResponseFromJSON(jsonValue))
  }

  /**
   */
  async getFarmsHolderBonuses(initOverrides?: RequestInit): Promise<HolderBonusesResponse> {
    const response = await this.getFarmsHolderBonusesRaw(initOverrides)
    return await response.value()
  }

  /**
   */
  async getNextRewardRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Bonuses>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/private/bonuses/next-reward`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, (jsonValue) => BonusesFromJSON(jsonValue))
  }

  /**
   */
  async getNextReward(initOverrides?: RequestInit): Promise<Bonuses> {
    const response = await this.getNextRewardRaw(initOverrides)
    return await response.value()
  }

  /**
   */
  async getTotalEarnedRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Bonuses>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/private/bonuses/total-earned`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, (jsonValue) => BonusesFromJSON(jsonValue))
  }

  /**
   */
  async getTotalEarned(initOverrides?: RequestInit): Promise<Bonuses> {
    const response = await this.getTotalEarnedRaw(initOverrides)
    return await response.value()
  }
}
